/** Simple PDF export utility — opens print window with content + clinical disclaimer watermark. */
export function exportToPDF(title, content) {
  const w = window.open("", "_blank", "width=900,height=700");
  if (!w) return;
  const html = `<!DOCTYPE html><html><head><title>${title}</title>
  <style>
    @page { margin: 0.6in; }
    body { font-family: 'IBM Plex Sans', Arial, sans-serif; max-width: 720px; margin: 40px auto; color:#1A1025; line-height: 1.6; position: relative; }
    h1 { color: #4A0E8F; border-bottom: 2px solid #4A0E8F; padding-bottom: 8px; }
    .meta { color: #6E6380; font-size: 12px; margin-bottom: 24px; }
    pre { white-space: pre-wrap; font-family: 'IBM Plex Sans', Arial, sans-serif; }
    .disclaimer-top {
      border: 1px solid #FCD34D; background: #FFFBEB; color: #78350F;
      padding: 10px 14px; font-size: 11px; line-height: 1.45;
      border-radius: 6px; margin-bottom: 20px;
    }
    .disclaimer-top strong { color: #78350F; }
    .footer {
      margin-top: 40px; padding-top: 16px; border-top: 1px solid #E9E3F5;
      color: #6E6380; font-size: 11px;
    }
    .watermark {
      position: fixed; inset: 0; pointer-events: none; z-index: -1;
      display: flex; align-items: center; justify-content: center;
    }
    .watermark span {
      font-size: 72px; color: rgba(74,14,143,0.07); transform: rotate(-30deg);
      font-weight: 700; letter-spacing: 0.06em;
    }
    @media print {
      .watermark { display: flex; }
    }
  </style></head><body>
    <div class="watermark"><span>AI-GENERATED · DECISION SUPPORT</span></div>
    <h1>${title}</h1>
    <div class="meta">ZidaMD · Built to adapt. Designed to perform. • ${new Date().toLocaleString()}</div>
    <div class="disclaimer-top">
      <strong>AI-GENERATED — CLINICAL DECISION SUPPORT ONLY.</strong>
      This output was produced by an AI system and may be inaccurate, incomplete or outdated.
      Verify all clinical content independently before acting. Not a substitute for licensed practitioner judgment.
      Not FDA cleared. © CamelionAI LLC — Patent Pending USPTO #64/078,696.
    </div>
    <pre>${(content || "").replace(/</g, "&lt;")}</pre>
    <div class="footer">Patent Pending USPTO #64/078,696 · ZidaMD by CamelionAI LLC · Boca Raton, FL · Support: admin@zidamd.com</div>
    <script>setTimeout(()=>window.print(),300)</script>
  </body></html>`;
  w.document.write(html);
  w.document.close();
}
